/*
 * Author: Dw
 * File Created: Monday, 24-08-05 04:17 pm
 * Last Modified: Wednesday, 25-04-16 03:09 pm, by Harper Yan
 */

import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Grid, Stack } from '@mui/material';
import { Flex } from '@ucard/ds/containers';
import { useScreenSize } from '@ucard/ds/utils';
import { DeCardVisa } from '@/animations';
import Image from '@/components/Image';
import SectionBox from '@/components/LandingContainer/SectionBox';
import useLanguage from '@/hooks/useLanguage';
import { staticImgPrefix } from '@/utils/prefix';
import { ApplyButton, MainText, SubText } from './style';
import TypingTextGroup from './TypingTextGroup';
const Hero = () => {
  const {
    t
  } = useTranslation('home');
  const {
    curLocale
  } = useLanguage();
  const router = useRouter();
  const isXs = useScreenSize('xs');
  return <SectionBox layerSx={{
    background: 'black',
    position: 'relative',
    pt: ['48px', '92px'],
    pb: ['12px', '40px']
  }} data-sentry-element="SectionBox" data-sentry-component="Hero" data-sentry-source-file="index.tsx">
      <Grid container data-sentry-element="Grid" data-sentry-source-file="index.tsx">
        {/* <Background/> */}
        <Grid alignItems="center" display="flex" item md={4} order={{
        xs: 2,
        sm: 1
      }} pb={[6, 6, 6]} pt={[4, 6, 6]} sm={6} xs={12} zIndex={1} data-sentry-element="Grid" data-sentry-source-file="index.tsx">
          <Stack alignItems={isXs ? 'center' : 'flex-start'} justifyContent="center" mt={{
          xs: 0,
          sm: 0
        }} mx={isXs ? 'auto' : 'unset'} position="relative" data-sentry-element="Stack" data-sentry-source-file="index.tsx">
            <Stack alignItems={isXs ? 'center' : 'flex-start'} width="100%" data-sentry-element="Stack" data-sentry-source-file="index.tsx">
              <Flex data-sentry-element="Flex" data-sentry-source-file="index.tsx">
                <MainText sx={{
                mr: curLocale === 'en' ? 2 : 0
              }} data-sentry-element="MainText" data-sentry-source-file="index.tsx">
                  {t('hero.the')}
                </MainText>
                <TypingTextGroup texts={[t('hero.typing-text.0'), t('hero.typing-text.1'), t('hero.typing-text.2')]} data-sentry-element="TypingTextGroup" data-sentry-source-file="index.tsx" />
              </Flex>
              <MainText data-sentry-element="MainText" data-sentry-source-file="index.tsx">{t('hero.way-to-spend')}</MainText>
            </Stack>

            <SubText sx={{
            mt: [2, 2.5]
          }} textAlign={isXs ? 'center' : 'left'} data-sentry-element="SubText" data-sentry-source-file="index.tsx">
              {t('hero.description')}
            </SubText>

            {/* <ApplyButton color='primary' onClick={() => { router.push('/signup'); }} sx={{ */}
            <ApplyButton color="primary" onClick={() => {
            router.push('/signup');
          }} sx={{
            mt: [3, 4],
            '&:hover': {
              background: '#7E61F3'
            },
            cursor: 'pointer'
          }} data-sentry-element="ApplyButton" data-sentry-source-file="index.tsx">
              {t('apply-btn')}
            </ApplyButton>
          </Stack>
        </Grid>
        <Grid alignItems="center" display="flex" item md={8} order={{
        xs: 1,
        sm: 2
      }} pb={[0, 6, 6]} pt={[6, 6, 6]} px={[2, 0]} sm={6} xs={12} data-sentry-element="Grid" data-sentry-source-file="index.tsx">
          <DeCardVisa height="100%" width="100%" data-sentry-element="DeCardVisa" data-sentry-source-file="index.tsx" />
        </Grid>
      </Grid>
    </SectionBox>;
};
export default Hero;